import React from 'react';
import Header from "../../Layouts/Header";

import Toast from "../../Components/Toast";
import Loading from "../../Layouts/Loading";

import {useNavigate, useParams} from "react-router-dom";

import LogoPic from "../../Assets/Images/logo.png";
import API from "../../Services/API";
import {toast} from "react-toastify";

const Register = () => {
    const navigate = useNavigate();
    const {id} = useParams();

    const [isLoaded, setIsLoaded] = React.useState(true);
    const [email, setEmail] = React.useState('');
    const [password, setPassword] = React.useState('');
    const [name, setName] = React.useState('');
    const [surname, setSurname] = React.useState('');
    const [phone, setPhone] = React.useState('');
    const [content, setContent] = React.useState([]);

    React.useEffect( () => {
        API.getContent('register')
            .then((response) => {
                setContent(response.data)
                setIsLoaded(true)
            })
    }, [])

/*    React.useEffect(() => {
        const match = document.cookie.match(new RegExp('(^| )auth=([^;]+)'));
        const token = match ? match[2] : null;
        if(token) {
            if(window.localStorage.getItem("needRegistration")){
                navigate('/register');
                return;
            }
            navigate('/home');
        }
        setTimeout(() => {
            window.scrollTo({top: 0, behavior: 'smooth'});
        }, 400)
    }, [navigate]);*/


    const onRegister = () => {
        setIsLoaded(false);
        const request = {
            email,
            password,
            name,
            surname,
            phone
        }
        API.register(request)
            .then((response) => {

                setIsLoaded(true);
                toast.success(response.message);
                const expire_date = new Date(new Date().setFullYear(new Date().getFullYear() + 1));
                document.cookie = `auth=${response.data.token}; expires=${expire_date}; path=/`;
                setTimeout (() => {
                  window.location.replace('/');
                },1500)
            })
            .catch((error) => {
                if(error.status === 500) {
                    toast.error('Failed To Register. Check Username And Password And Try Again')
                }
                setIsLoaded(true);
                if (error.response) {
                    toast.error(error.response.data.message);

                } else {
                    toast.error(error.message);

                }
            });
    }

    return (
        <React.Fragment>
            <Header/>

            <Toast/>
            {
                !isLoaded && <Loading/>
            }

            <section className="h-100 gradient-form" >
                <div className="container py-5 h-100">
                    <div className="row d-flex justify-content-center align-items-center h-100">
                        <div className="col-xl-10">
                            <div className="card rounded-3 text-black">
                                <div className="row g-0">
                                    <div className="col-lg-6">
                                        <div className="card-body p-md-5 mx-md-4">

                                            <div className="text-center">
                                                <img
                                                    src={LogoPic}
                                                    alt="logo"
                                                width='100'
                                                />
                                                <h4 className="mt-3 mb-5 pb-1">CheapShip Group</h4>
                                            </div>


                                                <p>Please Fill The Following Fields</p>

                                                <div  className="form-outline mb-3">
                                                    <input type="text" id="name" className="form-control"
                                                           placeholder="Name"
                                                    value={name}
                                                           onChange={(val) => {
                                                               setName(val.target.value)
                                                           }}
                                                    />
                                                    <label className="form-label"
                                                           htmlFor="name"></label>
                                                </div>


                                                <div  className="form-outline mb-3">
                                                    <input type="text" id="surname" className="form-control"
                                                           placeholder="Surname"
                                                    value={surname}
                                                           onChange={(val) => {
                                                               setSurname(val.target.value)
                                                           }}
                                                    />
                                                    <label className="form-label"
                                                           htmlFor="surname"></label>
                                                </div>


                                                <div  className="form-outline mb-3">
                                                    <input type="email" id="form2Example11" className="form-control"
                                                           placeholder="Email Address"
                                                    value={email}
                                                           onChange={(val) => {
                                                               setEmail(val.target.value)
                                                           }}
                                                    />
                                                    <label className="form-label"
                                                           htmlFor="form2Example11"></label>
                                                </div>

                                                <div  className="form-outline mb-3">
                                                    <input type="password" id="form2Example22"
                                                           className="form-control"
                                                           value={password}
                                                           placeholder=" Password"
                                                           onChange={(val) => {
                                                               setPassword(val.target.value)
                                                           }}
                                                    />
                                                    <label className="form-label"
                                                           htmlFor="form2Example22"></label>
                                                </div>

                                                <div  className="form-outline mb-3">
                                                    <input type="number" id="form2Example22"
                                                           className="form-control"
                                                           value={phone}
                                                           placeholder=" Phone Number"
                                                           onChange={(val) => {
                                                               setPhone(val.target.value)
                                                           }}
                                                    />
                                                    <label className="form-label"
                                                           htmlFor="form2Example22"></label>
                                                </div>

                                                <div className="text-center pt-1 mb-5 pb-1">
                                                    <button
                                                            className="btn btn-primary btn-block fa-lg gradient-custom-2 mb-3"
                                                            type="button"

                                                    onClick={onRegister}
                                                    >
                                                        Sign Up
                                                    </button>

                                                </div>



                                        </div>
                                    </div>
                                    <div className="col-lg-6 d-flex align-items-center gradient-custom-2">
                                        <div className="text-white px-3 py-4 p-md-5 mx-md-4">
                                            <h4 className="mb-4">
                                                {content.title}
                                            </h4>
                                            <div className="small mb-0">

                                                <p dangerouslySetInnerHTML={{__html: content.brief_content}}></p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

        </React.Fragment>
    );
};

export default Register;